import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import Text from '@/components/v4/Text';
import { useSelector } from 'react-redux';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';
import config from '../../../../../config.json';
import { useTriggerForm } from '../useTriggerForm.js';
import { FORM_FIELD_PATHS } from '../triggerFormConstants.js';

const TriggerType = ({ darkMode, errors, touched, isCompanyAdmin }) => {
    const { editMode } = walkthroughIds;
    const [isHovered, setIsHovered] = useState(false);

    const { requiredScope } = useSelector((state) => state.login);
    const { currentCompany, currentPartner, currentWholesaler } = useSelector(
        (state) => state.navigationLists,
    );
    const { formData, updateFormData, mode } = useTriggerForm();

    const triggerType = () => {
        return config.triggers.type.slice(0, requiredScope / 20);
    };

    const handleSelectChange = (item) => {
        const selectedType = item?.name || item;

        updateFormData(FORM_FIELD_PATHS.TRIGGER_TYPE, selectedType);
        updateFormData(
            FORM_FIELD_PATHS.COMPANY_ID,
            selectedType === 'Company' ? (currentCompany ?? '') : '',
        );
        updateFormData(
            FORM_FIELD_PATHS.PARTNER_ID,
            selectedType === 'Partner' ? (currentPartner ?? '') : '',
        );
        updateFormData(
            FORM_FIELD_PATHS.WHOLESALER_ID,
            selectedType === 'Wholesaler' ? (currentWholesaler ?? '') : '',
        );
        updateFormData(FORM_FIELD_PATHS.EVENT_ID, '');
    };

    const triggerTypeData = triggerType().map((type) => ({
        id: type,
        name: type,
    }));

    return (
        <FormControl
            sx={{ margin: '0 !important', position: 'relative' }}
            isInvalid={!!errors?.triggerType && touched?.triggerType}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                {isCompanyAdmin ? (
                    <Text marginInlineEnd={3} sx={formLabelStyling(darkMode)}>
                        Type
                    </Text>
                ) : (
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Type
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                )}
                <Box flex={1} maxWidth="400px">
                    {isCompanyAdmin ? (
                        <Box>
                            <Text width="100%" paddingTop="22px">
                                {formData?.triggerType || 'N/A'}
                            </Text>
                        </Box>
                    ) : (
                        <Field
                            component={DropDown}
                            id="triggerType"
                            name="triggerType"
                            data={triggerTypeData}
                            readOnly={mode === 'Edit'}
                            shownValue="name"
                            currentId={formData?.triggerType}
                            selectedId="id"
                            placeholder="Select Type"
                            width="100%"
                            alphabetical={false}
                            handleSelectChange={handleSelectChange}
                            isLoading={false}
                            darkMode={darkMode}
                            walkthroughId={editMode.ufTypeSelect}
                            validate={(value) => {
                                if (!value && !isCompanyAdmin) {
                                    return 'Please select a trigger type';
                                }
                            }}
                        />
                    )}
                </Box>
                <TriggerFieldToolTip
                    isVisible={isHovered}
                    label="Select the type of trigger for this automation"
                    ariaLabel="trigger-type-tip"
                />
            </Stack>
        </FormControl>
    );
};

export default TriggerType;
